"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncModule = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const floating_page_1 = require("client/components/page/floating-page");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const react_1 = require("react");
const React = require("react");
const store_3 = require("../../../sites/modules/sites-list/store");
const google_inventory_1 = require("./modules/google-inventory");
const google_medicine_1 = require("./modules/google-medicine");
const google_patients_1 = require("./modules/google-patients");
const google_providers_1 = require("./modules/google-providers");
const google_sites_1 = require("./modules/google-sites");
require("./google-sync.less");
/** A static list of sites we currently have access to the medlogs for. */
const sites = ["SWC", "KROL"];
/**
 * This module leaps through an initial handle click on sync and imports data
 * from google sheets based on a series of chained promises.
 * @returns void
 */
class SyncModule extends react_1.Component {
    constructor() {
        super(...arguments);
        this.log = [];
        this.lock = false;
        this.onHandleClickLiveSync = () => {
            this.lock = true;
            this.log.push(["Importing Sites... ", ""]);
            this.setState({});
            this.onHandleClickLiveSyncSites();
        };
        this.onHandleClickLiveSyncSites = () => {
            this.log.push(["Importing Providers... ", ""]);
            this.setState({});
            google_sites_1.sitesSync().then(() => {
                this.log[0][1] = `Complete!`;
                this.onHandleClickLiveSyncProviders();
            });
        };
        this.onHandleClickLiveSyncProviders = () => {
            this.setState({});
            store_3.sitesListStore
                .loadSites()
                .then(google_providers_1.providersSync)
                .then(async () => {
                this.log[1][1] = `Complete!`;
                this.setState({});
                for (const siteName of sites) {
                    this.log.push([`Importing Pharmacy - ${siteName}... `, ""]);
                    await this.onHandleClickLiveSyncPatients(siteName);
                    this.log[this.log.length - 1][1] = "Complete!";
                }
                alert("Sync Completed");
                window.location.reload();
            });
        };
        this.onHandleClickLiveSyncPatients = (siteName) => {
            this.setState({});
            return store_3.sitesListStore
                .loadSites()
                .then(() => google_patients_1.patientsSync(siteName))
                .then(() => {
                this.setState({});
                return this.onHandleClickLiveSyncInventory(siteName);
            })
                .then(() => {
                this.onHandleClickLiveSyncMedicine();
            });
        };
        this.onHandleClickLiveSyncInventory = (siteName) => {
            this.setState({});
            return store_3.sitesListStore
                .loadSites()
                .then(() => google_inventory_1.inventorySync(siteName))
                .then(() => {
                this.setState({});
                return Promise.resolve;
            });
        };
        this.onHandleClickLiveSyncMedicine = () => {
            this.log.push(["Importing Medicine Data... ", ""]);
            this.setState({});
            return store_3.sitesListStore
                .loadSites()
                .then(google_medicine_1.medicineSync)
                .then(() => {
                this.log[this.log.length - 1][1] = "Complete!";
                this.setState({});
            });
        };
        this.onHandleClickInsuranceRequest = () => {
            this.lock = true;
            this.log.push(["Requesting Insurance Information... ", ""]);
            this.setState({});
            store_1.patientsStore.syncInsuranceReqeust();
        };
    }
    componentWillMount() {
        // sitesListStore.loadSites();
        store_3.sitesListStore.loadSitesNoRelation();
    }
    render() {
        return (React.createElement("div", { className: "sync" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "sync__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Live Sync", subLabel: "Import Live Data from Google Sheets" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "sync__wrapper" },
                    this.renderSyncButton(),
                    React.createElement("ul", null, this.lock &&
                        this.log.map((e) => (React.createElement("li", null,
                            e[0],
                            " ",
                            React.createElement("strong", { style: { color: "green" } }, e[1])))))))));
    }
    /**
     * Renders our sync button based user permissions. Only administrators and
     * developers should be able to access this feature.
     * @returns void
     */
    renderSyncButton() {
        const user = store_2.usersStore.user.value;
        const hasPermission = user && (user.admin || user.siteAdmin);
        return hasPermission ? (React.createElement(react_1.Fragment, null,
            React.createElement("p", null,
                "This feature will import live data from IMB's Google Sheets, populating ",
                React.createElement("strong", null, "Pharmacies"),
                " with their",
                " ",
                React.createElement("strong", null, "Inventory"),
                ", ",
                React.createElement("strong", null, "Providers"),
                ", and",
                " ",
                React.createElement("strong", null, "Patients"),
                ". This process can take",
                " ",
                React.createElement("strong", null, "upwards of five minutes"),
                " to complete and should not be interrupted. Your browser will refresh when all of the tasks have been completed."),
            React.createElement(button_1.MaterialButton, { className: "sync__btn", primary: true, onClick: this.onHandleClickLiveSync, disabled: this.lock }, "Run Live Sync"),
            this.lock && (React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "sync__loading-indicator" })),
            React.createElement("p", null,
                "This button will request for Insurance Information for patients currently in the Database that do not currently have insurance information associated with them.",
                React.createElement("strong", null,
                    " ",
                    "Make sure the Live Sync has been ran before attempting an insurance request.",
                    " ")),
            React.createElement(button_1.MaterialButton, { className: "sync__btn", primary: true, onClick: this.onHandleClickInsuranceRequest, disabled: this.lock }, "Request Patient Insurance Information"))) : (React.createElement("p", null,
            React.createElement("strong", null, "Permission denied; please seek administration approval.")));
    }
}
__decorate([
    mobx_1.observable
], SyncModule.prototype, "log", void 0);
__decorate([
    mobx_1.observable
], SyncModule.prototype, "lock", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickLiveSync", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickLiveSyncProviders", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickLiveSyncPatients", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickLiveSyncInventory", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickLiveSyncMedicine", void 0);
__decorate([
    mobx_1.action
], SyncModule.prototype, "onHandleClickInsuranceRequest", void 0);
exports.SyncModule = SyncModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/google-sync.tsx
// module id = 3114
// module chunks = 0